import { ClassListCombinedProps } from './types';

const usePresenter = (props: ClassListCombinedProps): ClassListCombinedProps => {
  return props;
};

export default usePresenter;
